<template>
    <div>
      <el-row class="tcf-row">
        <el-col class="card">
          <div class="tcf-notedit" v-if="!isauth">
            <div class="tcf-notedit-spinner" v-if="islive">
              未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
            </div>
            <div class="tcf-notedit-spinner" v-if="!islive">
              授权小程序未开通直播权限，请前往微信公众平台开通小程序直播权限
            </div>
          </div>
          <div class="card-body">
            <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
              <el-form-item label="状态">
                <el-select v-model="searchForm.mark" clearable style="width: 100px">
                  <el-option label="未审核" :value="0" />
                  <el-option label="审核中" :value="1" />
                  <el-option label="审核通过" :value="2" />
                  <el-option label="审核失败" :value="3" />
                </el-select>
              </el-form-item>
              <el-form-item label="搜索关键字">
                <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加商品</el-button>
              </el-form-item>
            </el-form>
            <div class="card-content" v-loading="loading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-bottom: 20px">
                <el-table-column
                  label="商品图片"
                  align="center"
                  width="120">
                  <template slot-scope="scope">
                    <el-image
                      :src="scope.row.imgurl"
                      fit="cover"
                      style="width: 40px;height: 40px;"
                      :preview-src-list="[scope.row.imgurl]">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span style="font-weight: bold">{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品金额"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.pricetype === 1" style="color: #F56C6C">{{scope.row.price}}</span>
                    <span v-if="scope.row.pricetype === 2" style="color: #F56C6C">{{scope.row.price}}～{{scope.row.price2}}</span>
                    <s v-if="scope.row.pricetype === 3" style="color: #999">{{scope.row.price}}</s>
                    <span v-if="scope.row.pricetype === 3" style="color: #F56C6C;margin-left: 10px">{{scope.row.price2}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="100"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" type="danger">审核失败</el-tag>
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">审核中</el-tag>
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">未审核</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                    <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="total>0"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        :title="editTitle"
        :visible.sync="dialogVisible"
        width="60%"
        top="10vh"
        :destroy-on-close="true"
        :lock-scroll="true"
        :append-to-body="true">
        <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="dilogrules">
          <el-form-item label="商品名称" prop="name">
            <el-input placeholder="请输入商品名称" show-word-limit maxlength="50" v-model="editForm.name"/>
          </el-form-item>
          <el-form-item label="关联案例" prop="caseid">
            <SelectCaseList v-model="editForm.caseid" :bid="bid" :olddataid="oldcaseid"/>
          </el-form-item>
          <el-form-item label="商品图片" prop="goodsimg">
            <div style="color:#99a9bf;font-size: 12px"> 图片尺寸不得超过300像素 * 300像素，且大小不得超过1M</div>
            <SingleImgRestrict :key="goodsimgkey" v-model="editForm.goodsimg" :max="300" :oldurl="editForm.oldgoodsimgurl" :restrict="1"/>
          </el-form-item>
          <el-form-item label="价格类型" prop="pricetype">
            <el-radio-group v-model="editForm.pricetype">
              <el-radio :label="1" @change="clearPrice">一口价</el-radio>
              <el-radio :label="2" @change="clearPrice">价格区间</el-radio>
              <el-radio :label="3" @change="clearPrice">折扣价</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="价格(元)" prop="price1" v-if="editForm.pricetype===1">
            <el-input v-model="editForm.price1" style="width:160px"/>
          </el-form-item>
          <el-form-item label="价格(元)"  v-if="editForm.pricetype===2">
            <el-row>
              <el-col :span="4">
                <el-form-item prop="price1">
                  <el-input v-model="editForm.price1" style="width: 160px"/>
                </el-form-item>
              </el-col>
              <el-col :span="1">～</el-col>
              <el-col :span="4">
                <el-form-item prop="price2">
                  <el-input v-model="editForm.price2" style="width: 160px"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="价格(元)"  v-if="editForm.pricetype===3">
            <el-row>
              <el-col :span="5">
                <el-form-item prop="price1">
                  原价 <el-input v-model="editForm.price1" style="width: 160px"/>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item prop="price2">
                  现价 <el-input v-model="editForm.price2" style="width: 160px"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelLiveGoodsList, editDelLiveGoods, delDelLiveGoods, uploadFileWx, getDelShopInfo } from '@/api/dealer'
import SingleImgRestrict from '@/components/upload/SingleImgRestrict'
import SelectCaseList from '@/components/SelectCaseList/selectcaselist'
import { getDealerDetail } from '@/api/work'
export default {
  name: 'delzbsp',
  computed: {
    user: getUser
  },
  components: {
    SingleImgRestrict,
    SelectCaseList
  },
  data() {
    const checkPrice = (rule, value, callback) => {
      if (value !== '') {
        if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
          callback(new Error('请填写正确的价格'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      bid: 0,
      searchForm: {
        mark: null,
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dilogrules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        price1: [{ required: true, validator: checkPrice, trigger: 'blur', message: '商品金额不能为空' }],
        price2: [{ required: true, validator: checkPrice, trigger: 'blur', message: '商品金额不能为空' }],
        goodsimg: [{ required: true, message: '请上传商品图片', trigger: 'change' }],
        pricetype: [{ required: true, message: '请选择价格类型', trigger: 'change' }],
        money: [{ required: true }],
        caseid: [{ required: true, message: '请选择关联案例', trigger: 'change' }]
      },
      editForm: {
        dlgid: 0,
        name: '',
        price1: null,
        price2: 0,
        goodsimg: null,
        pricetype: 1,
        oldgoodsimgurl: '',
        caseid: null
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      goodsimgkey: '',
      oldcaseid: null,
      wximg: '',
      isauth: true,
      islive: true
    }
  },
  created() {
    getDealerDetail({ delid: this.user.delid }).then(response => {
      if (response.data.brandlst.length > 0) {
        this.bid = response.data.brandlst[0].bid
      }
      this.getData()
    })
    getDelShopInfo({ delid: this.user.delid }).then(response => {
      if (response.data !== null && response.data !== undefined) {
        if (response.data.appid !== null && response.data.appid !== '' && response.data.appid !== undefined) {
          if (response.data.islive === 0) {
            this.islive = false
            this.isauth = false
          }
        } else {
          this.isauth = false
        }
      } else {
        this.isauth = false
      }
    })
  },
  methods: {
    clearPrice() {
      this.editForm.price1 = null
      this.editForm.price2 = 0
    },
    getData() {
      this.loading = true
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.searchForm.mark,
        search: this.searchForm.search
      }
      getDelLiveGoodsList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加直播商品'
        this.editForm.dlgid = 0
        this.editForm.name = ''
        this.editForm.price1 = null
        this.editForm.price2 = 0
        this.editForm.goodsimg = null
        this.editForm.pricetype = 1
        this.editForm.oldgoodsimgurl = ''
        this.editForm.caseid = null
        this.caseid = null
      } else {
        this.editTitle = '编辑直播商品'
        this.editForm.dlgid = row.dlgid
        this.editForm.name = row.name
        this.editForm.price1 = row.price
        this.editForm.price2 = row.price2
        this.editForm.goodsimg = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.pricetype = row.pricetype
        this.editForm.oldgoodsimgurl = row.imgurl
        this.editForm.caseid = row.url
        this.caseid = row.url
      }
      this.goodsimgkey = (new Date().getTime() + 33).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            uploadFileWx({ imgid: this.editForm.goodsimg.imgid, type: 'image' }).then(response => {
              this.wximg = response.msg
              const data = {
                delid: this.user.delid,
                dlgid: this.editForm.dlgid,
                name: this.editForm.name,
                imgid: this.editForm.goodsimg.imgid,
                pricetype: this.editForm.pricetype,
                price: this.editForm.price1,
                price2: this.editForm.price2,
                url: this.editForm.caseid,
                wximg: this.wximg
              }
              editDelLiveGoods(data).then(response => {
                this.eidtLoading = false
                this.$message({
                  type: 'success',
                  message: '提交成功'
                })
                this.Search()
                this.dialogVisible = false
              }).catch(() => {
                this.eidtLoading = false
              })
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此商品吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delDelLiveGoods({ dlgid: row.dlgid, goodsid: row.goodsid, delid: row.delid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
